export enum SkinType {
  DEMANDING = 'DEMANDING',
  NORMAL = 'NORMAL',
  SENSITIVE = 'SENSITIVE',
  IMPURE = 'IMPURE',
  DRY = 'DRY',
}

export enum ProductLine {
  ESSENTIAL = 'ESSENTIAL',
  BEAUTY_ELEMENTS = 'BEAUTY_ELEMENTS',
  BODY_SCIENCE = 'BODY_SCIENCE',
  HAIR = 'HAIR',
  HYDRATING = 'HYDRATING',
  MELA_WHITE = 'MELA_WHITE',
  MEN = 'MEN',
  REGULATING = 'REGULATING',
  SENSITIVE = 'SENSITIVE',
  VITALITY = 'VITALITY',
  GREEN_PEEL = 'GREEN_PEEL',
}

export enum ProductType {
  AMPOULES = 'AMPOULES',
  DAY_CARE = 'DAY_CARE',
  NIGHT_CARE = 'NIGHT_CARE',
  SERUM = 'SERUM',
  SAMPLES = 'SAMPLES',
  SUN_CARE = 'SUN_CARE',
  EYE_CARE = 'EYE_CARE',
  BODY_CARE = 'BODY_CARE',
  CLEANSER = 'CLEANSER',
  SPECIAL = 'SPECIAL',
  PROMOTION_SIZES = 'PROMOTION_SIZES',
  PROMOTION_MATERIAL = 'PROMOTION_MATERIAL',
  OUTLET = 'OUTLET',
}
